module.exports = __webpack_public_path__ + "static/img/ind_ban_011.9c4ef84c.jpeg";